module.exports = __webpack_public_path__ + "img/closeup-economist-using-calculator-while-going-through-bills-taxes-office.24f2a7fd.jpg";